import { useEffect, useState } from "react";
import parse from "html-react-parser";
import { FragmentProps } from "../../../interfaces/Publication";
import { usePublication } from "../../../hooks/usePublication";

const OVA = ({ fragment, rawMode = false }: FragmentProps) => {
  const { path } = usePublication();
  const [iframeHeight, setIframeHeight] = useState<number | string>(
    rawMode ? window.innerHeight - 120 : "auto"
  );

  // Solo aplica el ajuste dinámico cuando rawMode es true
  useEffect(() => {
    if (!rawMode) return;

    const handleResize = () => setIframeHeight(window.innerHeight - 120);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [rawMode]);

  const fullScreen = () => {
    const iframe = document.getElementById(`IFrame-${fragment.id}`) as any;
    if (!iframe) return;

    if (iframe.requestFullscreen) iframe.requestFullscreen();
    else if (iframe.mozRequestFullScreen) iframe.mozRequestFullScreen();
    else if (iframe.webkitRequestFullscreen) iframe.webkitRequestFullscreen();
    else if (iframe.msRequestFullscreen) iframe.msRequestFullscreen();
  };

  // Construcción del src del iframe
  const iframeSrc = fragment.urlObj
    ? fragment.urlObj.includes(
        "http://bucketvisualizadorinfografias.s3-website-us-east-1.amazonaws.com"
      )
      ? fragment.urlObj.replace(
          "http://bucketvisualizadorinfografias.s3-website-us-east-1.amazonaws.com",
          "https://d122h3yf1t4a88.cloudfront.net"
        )
      : fragment.urlObj
    : fragment.img
    ? `${path}images/${fragment.img.replace(".zip", "")}/${fragment.img.replace(
        ".zip",
        ".html"
      )}`
    : "";

  return (
    <figure
      className="image"
      id={`${fragment.type}${fragment.id}`}
      style={{ margin: "20px 0px" }}
    >
      {fragment.title && !rawMode && (
        <div className="source">{parse(fragment.title)}</div>
      )}

      <div className="media-wrapper__ova" style={{ position: "relative" }}>
        <button
          type="button"
          onClick={fullScreen}
          className="btn btn-rounded btn-rounded-primary tippy"
          data-tippy-content="Pantalla completa"
          aria-label="Pantalla completa"
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 10,
          }}
        >
          <span className="btn__icon">
            <i className="icon icon-vpro-enter-fullscreen"></i>
          </span>
        </button>

        <div
          className="sketchfab-embed-wrapper"
          style={
            rawMode
              ? {
                  position: "relative",
                  width: "100%",
                  height: `${iframeHeight}px`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }
              : {}
          }
        >
          <iframe
            title={fragment.title}
            id={`IFrame-${fragment.id}`}
            allow="autoplay; fullscreen; xr-spatial-tracking"
            src={iframeSrc}
            style={
              rawMode ? { border: "none", width: "100%", height: "100%" } : {}
            }
          ></iframe>
        </div>
      </div>

      {fragment.text && !rawMode && (
        <figcaption className="image__caption">
          {parse(fragment.text)}
        </figcaption>
      )}
    </figure>
  );
};

export default OVA;
